import { useQuery } from '@tanstack/react-query';

import { useProject } from '../../projects/context';
import { projectKeys, useProjectApi } from '../../projects/useProjectApi';

// useBrokerLeads: Kontakt-Leads und Regelgebiete des angemeldeten Maklers (ein Abruf für Reiter und Liste).
export function useBrokerLeads() {
  const { project } = useProject();
  const papi = useProjectApi();
  return useQuery({ queryKey: projectKeys.brokerLeads(project.id), queryFn: ({ signal }) => papi.fieldSalesLeads(signal), refetchInterval: 300_000 });
}
